import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    currentTemplate: {
        id: '',
        type: '',
        contents: '<div> <h2> Content </h2> </div>'
    },
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
